import { useEffect, useState } from 'react';
import { getSummary, subscribe, flushOutbox } from '@/lib/offlineOutbox';

/**
 * The Home screen's "N contacts waiting to sync" banner, backed by
 * offlineOutbox.js.
 *
 * Always reads getSummary() on mount rather than trusting any state left
 * over from before, so a page reload or a fresh launch shows the true
 * IndexedDB count immediately: a rep relaunching the app and seeing zero
 * pending when two are actually queued is the exact failure CLAUDE.md hard
 * rule 4 exists to prevent.
 */
export function useOutboxStatus() {
  const [summary, setSummary] = useState({ total: 0, stuck: 0, authExpired: 0 });

  useEffect(() => {
    let cancelled = false;
    const refresh = () => {
      getSummary().then((s) => { if (!cancelled) setSummary(s); });
    };
    refresh();
    const unsubscribe = subscribe(refresh);
    return () => { cancelled = true; unsubscribe(); };
  }, []);

  return { ...summary, flushNow: flushOutbox };
}
